import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FiMenu, FiLock, FiPhone } from 'react-icons/fi';
import ChangePasswordModal from '../../pages/Auth/ChangePasswordModal';
import ChangeMobileModal from '../../pages/Auth/ChangeMobileModal';

const Header = ({ onMenuClick }) => {
  const { user } = useSelector((state) => state.auth);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showChangeMobile, setShowChangeMobile] = useState(false);
  const location = useLocation();

  const getPageTitle = () => {
    const pathMap = {
      '/dashboard': 'Dashboard',
      '/pet-types': 'Pet Types',
      '/pet-breeds': 'Pet Breeds',
      '/states': 'States',
      '/cities': 'Cities',
      '/features': 'Features',
      '/pets': 'All Pets',
      '/users': 'Users',
    };
    return pathMap[location.pathname] || 'Dashboard';
  };

  const getUserInitials = () => {
    if (user?.ownerName) {
      return user.ownerName
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase();
    }
    return 'AD';
  };

  return (
    <header className="header">
      <div className="header-left">
        <button
          className="btn btn-icon btn-secondary"
          onClick={onMenuClick}
          style={{ display: 'none' }}
        >
          <FiMenu />
        </button>
        <h1 className="header-title">{getPageTitle()}</h1>
      </div>

      <div className="header-right">
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => setShowChangeMobile(true)}
          title={user?.mobile ? `Registered mobile: ${user.mobile}` : 'Change Mobile Number'}
        >
          <FiPhone style={{ marginRight: '6px' }} />
          Change Mobile
        </button>
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => setShowChangePassword(true)}
          title="Change Password"
        >
          <FiLock style={{ marginRight: '6px' }} />
          Change Password
        </button>
        <div className="header-user">
          <div className="header-avatar">{getUserInitials()}</div>
          <div className="header-user-info">
            <span className="header-user-name">{user?.ownerName || user?.email || 'Admin'}</span>
            <span className="header-user-role">{user?.role || 'Administrator'}</span>
          </div>
        </div>
      </div>
      <ChangeMobileModal
        isOpen={showChangeMobile}
        onClose={() => setShowChangeMobile(false)}
      />
      <ChangePasswordModal
        isOpen={showChangePassword}
        onClose={() => setShowChangePassword(false)}
      />
    </header>
  );
};

export default Header;
